import { Config } from 'src/Config';
import { SitemapResponse } from '@maverick/entity';
import { getSitemapHTML } from '@maverick/cms';
import { GetSitemapService } from '@maverick/sitecore';

const getRestaurants = async (): Promise<Array<string>> => {
    const slugs = new Array<string>();

    const response = await fetch(`${Config.Urls.Cms}/api/olo/v1.1/restaurants`, {
        headers: {
            Accept: '*/*',
            Host: new URL(Config.Urls.Cms).hostname,
            'User-Agent': `Maverick-${Config.Brand}-CMS/v4 (${Config.Env.Is}; ${Config.Urls.Cms})`,
        },
    });
    if (response.status === 200) {
        const data = await response.json();
        if (!data.restaurants || !Array.isArray(data.restaurants)) return slugs;

        data.restaurants.forEach((r: any) => {
            if (r.slug) slugs.push(r.slug);
        });
    }

    return slugs;
};

export const getServerSideProps = async () => {
    const [cmsPaths, restaurants] = await Promise.all([GetSitemapService.GetSitemap(), getRestaurants()]);

    const itemFiltered = cmsPaths.body as SitemapResponse;
    let sitemapItems = itemFiltered.sitemap.results.filter(
        (item) => item?.path?.startsWith(`/sitecore/content/BBI/${Config.Brand}`) && item.noIndex?.boolValue !== true
    );

    const urls = new Array<string>();

    sitemapItems.forEach((path) => {
        const url = path.path
            .replace(`/sitecore/content/BBI/${Config.Brand}/Home`, '')
            .replaceAll(' ', '-')
            .toLocaleLowerCase();
        if (urls.includes(url)) return;
        urls.push(`${Config.Urls.Cms}${url}`);
    });

    urls.push(Config.Urls.Order);
    restaurants.forEach((slug) => {
        if (urls.includes(slug)) return;
        urls.push(`${Config.Urls.Order}/menu/${slug}`);
    });
    return {
        props: {
            urls: Array.from(urls),
        },
    };
};

const Sitemap = ({ urls }: { urls: string[] }) => {
    return <div style={{ marginBottom: '100px' }} dangerouslySetInnerHTML={{ __html: getSitemapHTML(urls) }} />;
};

export default Sitemap;
